<script>
    // -- IMPORTS
    import ElementGroupList from './ElementGroupList.svelte';
    import FullLoading from '../Layout/FullLoading.svelte';

    // -- VARIABLES
    let { blockGroup: blockArray = $bindable([]) } = $props();
    let isLoading = $state(false);
</script>

<style lang="stylus">
    // -- IMPORTS

    @import '../../../constant.styl';
    @import '../../../mixin.styl';

    // -- ELEMENTS

    details
    {
        width: 100%;
        min-height: 3rem;
    }

    details > summary
    {
        list-style: none;
    }

    summary
    {
        position: relative;

        width: 100%;
        min-height: 3rem;
    }

    summary::-webkit-details-marker 
    {
        display: none
    }

    summary::after 
    {
        position: absolute;
        top: 50%;
        right: 0;

        content: url('/image/icon/down_caret.svg');

        transform: translateY(-50%);
        transition: all .2s ease;
    }

    details[open] summary:after
    {
        content: url('/image/icon/down_caret.svg');

        transform: translateY(-50%) rotate( -180deg );
    }

    // -- CLASSES

    .list-container
    {
        padding: 3rem;
        width: 100%;
        height: 100vh;

        display: flex;
        flex-direction: column;
        gap: 2rem;
        align-items: center;
    }

    .sortable-list-container
    {
        width: 100%;
        padding-bottom: 15rem;

        display: flex;
        flex-direction: column;
        gap: 0.5rem;
    }

    .sortable-list-item
    {     
        min-height: 5rem;
        max-width: 100%;
        border-radius: 0.5rem;
        padding: 1rem;

        background: rgba(27, 27, 27, 0.95);

        color: lightGoldColor;

        transition: all 0.2s linear;

        &:hover
        {
            background: pureBlackColor;
        }

        &:last-of-type
        {
            margin-bottom: 1rem;
        }
        
    }

    .sortable-list-item + .sortable-list-item
    {
        margin-top: 1rem;
    }

    .sortable-list-item-container
    {
        display: flex;
        gap: 1rem;
        align-items: center;

        width: 100%;
    }

    .item-header-container
    {
        display: flex;
        align-items: center;
        gap: .75rem;

        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 1.5rem;
    }

    .item-media-container
    {
        height: 4.25rem;
        width: 7.5rem;
    }

    .item-title
    {
        overflow: hidden;

        max-width: 100%;

        display: flex;
        align-items: center;
        gap: .5rem;

        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 1.5rem;
    }

    .item-accordion-content
    {
        margin-top: 1rem;
        width: 100%;
        
        cursor: grab;
    }
</style>


{#if isLoading}
    <FullLoading />
{:else}
    <div class="list-container">
        <ul class="sortable-list-container">
            {#key [blockArray]}
                {#each blockArray as section, sectionIndex}
                    <div class="card-list sortable-list-item">
                        <details class="item-container">
                            <summary class="item-header-container">
                                SECTION {sectionIndex + 1}
                            </summary>
                            <div class="item-accordion-content">
                                <ElementGroupList
                                    bind:blockGroupArray={ blockArray[sectionIndex] }
                                />
                            </div>
                        </details>
                    </div>
                {/each}
            {/key}
        </ul>
    </div>
{/if}